// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3TTxu","image":"Header_image__3RYmR","name":"Header_name__1Hw8-","info":"Header_info__1Eqjn","infoRow":"Header_infoRow__1kee2"};